import { Helmet } from 'react-helmet';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Check from '@zg-rentals/multibrand-ui/lib/icons/Check';
import Center from '@zg-rentals/multibrand-ui/lib/Center';
import Section from '@zg-rentals/multibrand-ui/lib/Section';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';

import sharedConfig from '../../../sharedConfig';

const iconSizes = {
  hotpads: '24',
  trulia: '42',
  zillow: '42',
};

class TourFeedbackSuccessPage extends React.Component {
  render() {
    const { brand } = this.props;

    const title = 'Thanks for the update!';
    const description = 'Your feedback helps us improve your experience.';
    const linkbackText = 'Search for homes.';

    let homeLink = '/';
    if (brand === sharedConfig.brands.zillow) {
      homeLink = '/renting';
    }

    return (
      <div className="TourFeedbackSuccessPage">
        <Helmet>
          <meta name="robots" content="noindex" />
          <title>Thank You!</title>
        </Helmet>
        <Container>
          <Section>
            <Center>
              <Check colorType="success" size={iconSizes[brand]} />

              <div className="stacked-lg">
                <Text type="h3">{title}</Text>
              </div>
              <div className="stacked-lg">
                <Text type="body">{description}</Text>
              </div>
            </Center>

            <Row>
              <Col>
                <Center>
                  <Link type="secondary" href={homeLink}>
                    {linkbackText}
                  </Link>
                </Center>
              </Col>
            </Row>
          </Section>
        </Container>
      </div>
    );
  }
}

TourFeedbackSuccessPage.propTypes = {
  brand: PropTypes.string,
};

const mapStateToProps = (state) => ({
  brand: state.app.brand,
});

export default connect(mapStateToProps)(TourFeedbackSuccessPage);
